<div class="beneficiary-timeline-container">
  <mat-tab-group>
    <mat-tab>     
      <ng-template mat-tab-label>
        <span class="common-bene-class-for-translation">Application Details</span>      
      </ng-template>
      <app-visa-timeline *ngIf="subTaskDetails && subTaskDetails['isOutsideImagility'] == 0 && stepList && stepList.length > 0"
         [receiptETADateRange]="receiptETADateRange"        
         [inputStepList]="stepList"
         [taskStatus]="subTaskDetails.taskStatus ? subTaskDetails.taskStatus.code:null"
         [primaryData]="primaryData"
         (onStepClick)="handleStepClick($event)">
      </app-visa-timeline>
    
    </mat-tab>

    <mat-tab>  
      <ng-template mat-tab-label>
        <span class="common-bene-class-for-translation">External Links</span>
      </ng-template>
      <div class="p-4">        
        <lib-external-links [inputData]="{ fromBenProfile: false, fromTask: true, subTaskType: subTaskDetails?.id }"></lib-external-links>
      </div>     
    </mat-tab>   
  </mat-tab-group>
</div>